import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { EditorEligibilityRule } from '../editor-eligibility-rule/editor-eligibility-rule.model';


@Component({
    selector: 'eas-editor-eligibility-rule',
    templateUrl: './editor-eligibility-rule.component.html',
    styleUrls: ['./editor-eligibility-rule.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleComponent implements OnInit {
  @Input() rule: EditorEligibilityRule;
  @Input() affirmative: boolean;

  constructor() {

  }

  ngOnInit() {

  }
}
